import { render, staticRenderFns } from "./ReviewSitesUpload.vue?vue&type=template&id=4801fc2c&scoped=true"
import script from "./ReviewSitesUpload.vue?vue&type=script&lang=js"
export * from "./ReviewSitesUpload.vue?vue&type=script&lang=js"
import style0 from "./ReviewSitesUpload.vue?vue&type=style&index=0&id=4801fc2c&prod&scoped=true&lang=css"
import style1 from "./ReviewSitesUpload.vue?vue&type=style&index=1&id=4801fc2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801fc2c",
  null
  
)

export default component.exports